<div class="ym-display-flex ym-flex-direction-column ym-gap-2" [class.error-occured]="error">
    <div class="label-container ym-display-flex ym-align-items-center ym-gap-3" *ngIf="showLabel">
        <div class="ym-text-color ym-display-flex ym-align-items-center ym-gap-2 ym-w-full">
            <span class="text ym-font-base ym-line-height-normal">{{label}}</span>
            <span class="optional-indicator ym-text-secondary ym-display-inline-block"
                *ngIf="!required && !hideOptional">
                <!-- <span class="icon ym-svg-sm ym-mt-n2">
                    <ym-icon [iconName]="iconNames.REQUIRED"></ym-icon>
                </span> -->
                (optional)
            </span>
            <span class="inline-info ym-svg-base" *ngIf="inlineInfo">
                <ym-inline-info [hideTooltip]="true">
                    {{inlineInfo}}
                </ym-inline-info>
            </span>
        </div>
    </div>
    <div class="content ym-display-flex ym-gap-3">
        <ym-date-input [showLabel]="false" [placeholder]="''" [error]="error" [errorText]="''" [disabled]="disabled"
            [showCalendarClearDate]="false" [value]="dateValue" (valueChange)="updateDateValue($event)"
            class="ym-w-full"></ym-date-input>
        <ym-time-input [showLabel]="false" [placeholder]="''" [error]="error" [errorText]="''" [disabled]="disabled"
            [value]="dateValue" (valueChange)="updateTimeValue($event)" class="ym-w-full"></ym-time-input>
    </div>
    <ym-button [type]="buttonTypes.GHOST_LINK" class="ym-ml-n4" *ngIf="dateValue && !disabled"
        (onClick)="clearField()">Clear</ym-button>
    <span class="error-text ym-font-sm ym-text-danger ym-display-block ym-line-height-normal"
        *ngIf="error">{{errorText}}</span>
</div>